import React, { useCallback, useState } from "react";
import Switch from "@mui/material/Switch";
import styles from "./UserLinkHome.module.scss";
import { Icons } from "../../icons/OlinkTypeIcons";
import pen from "../../../assets/svg/pen.svg";
import deleteIcon from "../../../assets/svg/delete.svg";
import { ELinkType, ILinkUpdateDTO } from "../../../interfaces/link.interface";
import add_cover_white from "../../../assets/svg/add_cover_white.svg";
import arrow from "../../../assets/svg/arrow-right--orange.svg";
import { ILinkContext } from "../../../interfaces/user.context";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { useApi } from "../../../providers/api.provider";
import { ILinkErrors } from "../../pages/OlinkAdd/OlinkAdd";
import { convertToBase64 } from "../../../services/image.service";
import { useUser } from "../../../providers/user.provider";
import { useGuest } from "../../../providers/guest.provider";
import { useWindowDimensions } from "../../../services/widthCheck.service";
import CropperForImage from "../../utils/CropperForImage";
import { useProfileRole } from "../../../hooks/useProfileRole";
import { ProtectedAction } from '../../utils/ProtectedAction';

interface IFile {
  fileImg: any;
}

interface IUserLinkHome {
  preview?: any;
  link: ILinkContext;
  role?: string | null;
  index: number;
  onReorder?: (id: number, index: number) => void;
  onVisible: (id: number, state: boolean) => void;
  onDelete: (id: number) => void;
  previewUrl?: string | null;
  onDownload?: ((id: number) => void) | null;
  // onDownloadList?: (id: number) => void;
}

interface ILinkForm {
  id: number | null;
  type: ELinkType | null;
  title: string | null;
  url: string | null;
  urlType: string | null;
  visible: boolean | null;
  cover?: { id: number | null; key: string | null; url: string | null };
  onUpdate: (
    title: string,
    url: string,
    urlType: string,
    cover: { id: number | null; key: string | null; url: string | null }
  ) => void;
}

interface IFormErrors {
  email: string;
}

const UserLinkHome = React.memo((props: IUserLinkHome) => {
  const user = useUser();
  const guest = useGuest();
  const [deleteState, setDeleteState] = useState(false);
  const [editState, setEditState] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(false);
  const [email, setEmail] = useState("");
  const [subscriptionMess, setSubscriptionMess] = useState(false);
  const { width } = useWindowDimensions();
  const [errors, setErrors] = useState<IFormErrors>({
    email: "",
  });
  const { canEdit } = useProfileRole();

  const getCover = (link: ILinkContext): any => {
    switch (link.type) {
      case ELinkType.Audio:
        return <Icons.Audio />;
      case ELinkType.Video:
        return <Icons.Video />;
      case ELinkType.ProLink:
        return <Icons.ProLink />;
      default:
        return null;
    }
  };

  const handleClickSubscriptionState = () => {
    setActiveSubscription(!activeSubscription);
  };

  const handleClickSubscriptionReopen = () => {
    setActiveSubscription(true);
    setSubscriptionMess(false);
  };

  const handleOnChangeGuestEmail = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEmail(event.target.value);
  };

  const handleClickSubscription = () => {
    setActiveSubscription(true);
    setSubscriptionMess(true);
  };

  const handleSubscription = async () => {
    const idLink = props.link.id;
    if (validateForm()) {
      handleClickSubscription();
      guest.addEmail(email, idLink).then((res) => {
        // setActiveSubscription(false);
        // setSubscriptionMess(false);
        setEmail("");
      });
    }
  };

  // let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validateForm = (): any => {
    const errs = { ...errors };
    let res = true;
    if (!email || email.length === 0) {
      errs.email = "Email is required";
      res = false;
    } else if (!reg.test(email)) {
      errs.email = "Email is incorrect";
      res = false;
    } else {
      errs.email = "";
    }
    setErrors(errs);
    return res;
  };

  const handleOnReorder = () => {
    props.onReorder && props.onReorder(props.link.id!, props.index);
  };
  const handleOnVisible = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onVisible && props.onVisible(props.link.id!, event.target.checked);
  };
  const handlerOnEdit = () => {
    setEditState(true);
  };
  const handlerOnDelete = () => {
    setDeleteState(true);
  };
  const handlerOnDeleteConfirmed = () => {
    props.onDelete && props.onDelete(props.link.id!);
  };
  const handlerOnEditClose = () => {
    setEditState(false);
  };
  const closeDelete = () => {
    setDeleteState(false);
  };
  const handleOnUpdate = async (
    title: string,
    url: string,
    urlType: string,
    cover: {
      id: number | null;
      key: string | null;
      url: string | null;
    }
  ) => {
    const [...newLinks] = user.profileLinks as any;
    const { ...newLink } = newLinks[props.index];
    newLink.url = url;
    newLink.urlType = urlType;
    newLink.title = title;
    newLink.cover = cover;
    newLinks[props.index] = newLink;
    user.setProfileLinks(newLinks);
  };
  // const handleDownloadList = () => {
  //   props.onDownload && props.onDownload();
  // };
  const handleDownloadList = () => {
    const idLink = props.link.id;
    props.onDownload && props.onDownload(idLink);
  };

  const EditForm = (props: ILinkForm) => {
    const api = useApi();
    const [title, setTitle] = useState(props.title);
    const [url, setUrl] = useState<string>(props.url || '');
    const [urlType, setUrlType] = useState<string>(props.urlType ||'0');
    const [cover, setCover] = useState<any>(props.cover);
    const [type] = useState(props.type);
    const [base64Url, setBase64Url] = useState<IFile>({
      fileImg: null,
    });

    const [errors, setErrors] = useState<ILinkErrors>({
      title: null,
      url: null,
      urlType: null,
      cover: null,
    });

    const [newCover, setNewCover] = useState<FormData | null>(null);
    const handleClickAddCover = (formData: FormData, picture: string) => {
      setNewCover(formData);
      handleOnChangeBase64(picture);
      user.setLoading(false);
    };

    const handleOnChangeBase64 = async (picture: any) => {
      const base64 = await convertToBase64(picture);
      setCover({ url: base64 });
    };

    const prepareUrl = (url: string) => {
      let res = '';
      if (!url) {
        return res;
      }
      if (url.includes('https://') || url.includes('http://')) {
        res = url;
      } else if (url.includes('mailto:')) {
        res = url.replace(/^mailto:/, "");
      } else if (url.includes('tel:')) {
        res = url.replace(/^tel:/, "");
      } else if (url.includes('sms:')) {
        res = url.replace(/^sms:/, "");
      } else if (url.includes('maps:')) {
        res = url.replace(/^maps:/, "");
      } else if (url.includes('geo:')) {
        res = url.replace(/^geo:/, "");
      } else {
        res = url;
      }
      return res;
    }

    const handleUpdateLink = async () => {
      user.setLoading(true);
      if (validate()) {
        /*const checkHttpsForUrl =
          !url?.startsWith("http://") && !url?.startsWith("https://")
            ? "https://" + url
            : url;*/
        const data: ILinkUpdateDTO = {
          type: props.type!,
          title: title!,
          url: ( props.type !== ELinkType.Separator ? formatUrl(prepareUrl(url), urlType) : prepareUrl(url) ),
          urlType: urlType
        };
        if (newCover) {
          try {
            await api.link
              .addCoverProLink(newCover, props.id!)
              .then((resCover: any) => {
                if (resCover) {
                  api.link.updateLink(props.id!, data).then((res) => {
                    if (res && props.onUpdate) {
                      props.onUpdate(res.title, res.url, res.urlType, resCover.data);
                    }
                    setDeleteState(false);
                    setEditState(false);
                  });
                }
              });
          } catch (err) {
            console.log(err);
            user.setLoading(false);
          }
        } else {
          await api.link.updateLink(props.id!, data).then(async (res) => {
            if (res && props.onUpdate) {
              if (
                res.type === "regular" ||
                res.type === "prolink" ||
                res.type === "subscription" ||
                res.type === "separator"
              ) {
                props.onUpdate(res.title, res.url, res.urlType, res.cover);
              } else {
                await api.link
                  .getPreviewImage(res.url)
                  .then((item) => {
                    const index = user?.previewImage?.findIndex((el: any) => {
                      return el.id === res.id;
                    });
                    const arr = user?.previewImage;
                    const updateImage = {
                      url: item.data.images[0].replace("http://", "https://"),
                      id: res.id,
                    };
                    arr[index] = updateImage;
                    user.setPreviewImage(arr);
                    props.onUpdate(res.title, res.url, res.urlType, res.cover);
                  })
                  .catch((err) => {
                    console.log(err);
                    user.setLoading(false);
                  });
                props.onUpdate(res.title, res.url, res.urlType, res.cover);
              }
            }
            setDeleteState(false);
            setEditState(false);
          });
        }
      }
      user.setLoading(false);
    };

    const handleOnChangeTitle = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const data = event.target.value.trim().replace(/\s+/g, " ");
      if (event.target.value.trim() === "") {
        setTitle(data);
      } else {
        setTitle(event.target.value.trimStart());
      }
    };

    const handleOnChangeUrl = (event: React.ChangeEvent<HTMLInputElement>) => {
      const data = event.target.value.trim().replace(/\s+/g, " ");
      const value = event.target.value.trim();
      const type = detectUrlType(value);
      if (value === "") {
        setUrl(data);
      } else {
        setUrl(value);
        setUrlType(type === '' ? urlType : type);
      }

      setErrors({
        ...errors,
        url: validateUrl(data, type === '' ? urlType : type),
      });
    };

    const handleDeleteCover = async () => {
      if (props.cover) {
        await api.link
          .deleteCoverProLink(props?.id as number)
          .then((res: any) => {
            let linksNew = [...user.profileLinks];
            const el_index = linksNew.findIndex((e) => e.id === props.id);
            linksNew[el_index].cover = null as any;
            user.setProfileLinks(linksNew);
            // user.setCurrentProfile((prevState: any) => ({
            //   ...prevState,
            //   links: linksNew,
            // }));
          });
      } else {
        setNewCover(null);
        setCover("");
      }
      setCover({ id: null, key: null, url: null });
    };

    const validate = (): boolean => {
      /*const reg =
        /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i;

      let validateUrl =
        url?.startsWith("https://") && url?.startsWith("http://")
          ? "https://" + url
          : url;*/
      const errs = { ...errors };
      let res = true;

      if (
        (type === "regular" || type === "prolink" || type === 'separator') &&
        (!title || title.length === 0)
      ) {
        errs.title = "Title is required!";
        res = false;
      } else {
        errs.title = null;
      }

      if (type !== "subscription" && type !== "separator") {
        const urlErrors = validateUrl(url, urlType);

        if (!url || url.length === 0 || urlErrors) {
          errs.url = urlErrors;
          res = false;
        } else {
          errs.url = null;
        }
      }
      setErrors(errs);
      return res;
    };

    const formatUrl = (url: string, urlType: string) => {
      let urlResult = '';
      switch (urlType) {
        case '0':
          urlResult =
              !url?.startsWith("https://") &&
              !url?.startsWith("http://")
                  ? "https://" + url
                  : url;
          break;
        case '1':
          urlResult =
              !url?.startsWith("mailto:")
                  ? "mailto:" + url
                  : url;
          break;
        case '2':
          urlResult =
              !url?.startsWith("tel:")
                  ? "tel:" + url
                  : url;
          break;
        case '3':
          urlResult =
              !url?.startsWith("sms:")
                  ? "sms:" + url
                  : url;
          break;
        case '4':
          urlResult =
              !url?.startsWith("maps:")
                  ? "maps:" + url
                  : url;
          break;
        case '5':
          urlResult =
              !url?.startsWith("geo:")
                  ? "geo:" + url
                  : url;
          break;
      }

      return urlResult;
    }

    const validateUrl = useCallback(
        (_url?: string | null, _urlType?: string | null) => {
          let error = null;
          _urlType = _urlType ? _urlType : urlType;
          const urlToValidate = !!_url ? _url : url;
          const validateUrl = formatUrl(urlToValidate, _urlType)

          switch (_urlType) {
            case '0':
              const regUrl = /^https?:\/\/(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
              if (!validateUrl || validateUrl.length === 0 || !regUrl.test(validateUrl)) {
                error = "Url is required!";
              }
              break;
            case '1':
              const regEmail = /^mailto:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\?.*)?$/;
              if (!urlToValidate || urlToValidate.length === 0 || !regEmail.test(validateUrl)) {
                error = "Email is required!";
              }
              break;
            case '2':
              const regTel = /^tel:\+?[0-9]{10,15}$/;
              if (!urlToValidate || urlToValidate.length === 0 || !regTel.test(validateUrl)) {
                error = "Phone number is required!";
              }
              break;
            case '3':
              const regSms = /^sms:\+?[0-9]{10,15}$/;
              if (!urlToValidate || urlToValidate.length === 0 || !regSms.test(validateUrl)) {
                error = "Phone number is required!";
              }
              break;
            case '4':
              const regMaps = /^maps:\/\/\?ll=[-+]?[0-9]{1,3}\.[0-9]+,[-+]?[0-9]{1,3}\.[0-9]+$/;
              if (!urlToValidate || urlToValidate.length === 0 || !regMaps.test(validateUrl)) {
                error = "Incorrect coordinates!";
              }
              break;
            case '5':
              const regGeo = /^geo:[-+]?[0-9]{1,3}\.[0-9]+,[-+]?[0-9]{1,3}\.[0-9]+(?:\?q=.*)?$/;
              if (!urlToValidate || urlToValidate.length === 0 || !regGeo.test(validateUrl)) {
                error = "Incorrect coordinates!";
              }
              break;
          }

          return error;
        },
        [url, urlType]
    );

    const detectUrlType = (_url: string) => {
      if (!_url) {
        return '';
      }
      if (_url.includes('https://') || _url.includes('http://')) {
        return '0';
      } else if (_url.includes('mailto:')) {
        return '1';
      } else if (_url.includes('tel:')) {
        return '2';
      } else if (_url.includes('sms:')) {
        return '3';
      } else if (_url.includes('maps:')) {
        return '4';
      } else if (_url.includes('geo:')) {
        return '5';
      } else {
        return '';
      }
    }

    const handleOnChangeUrlType = useCallback(
        (event: SelectChangeEvent<string>) => {
          const data = event.target.value;
          setUrlType(data);
          setErrors({
            ...errors,
            url: validateUrl(url, data),
          });
        },
        [url, errors, validateUrl]
    );

    return (
      <div className={"setting_card__top__form transition-500"}>
        {editState && type === ELinkType.ProLink ? (
          <>
            <label
              htmlFor="imgInputProLink"
              className={
                (cover ? "imgInput" + " imgInput__added" : "imgInput") +
                " " +
                (errors.cover ? "error" : "")
              }
            >
              <img className="imgInput__change" src={pen} alt="edit" />
            <ProtectedAction>
              <button className="imgInput__del" onClick={handleDeleteCover}>
                <img src={deleteIcon} alt="delete cover icon" />
              </button>
            </ProtectedAction>

              {!cover && canEdit ? (
                <>
                  <svg
                    width="48"
                    height="54"
                    viewBox="0 0 48 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask id="path-1-inside-1_1073_12020" fill="white">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.938773 14.031C0.436877 11.1969 2.29781 8.48634 5.12289 7.93654L10.6852 6.85405L11.2225 38.579C11.2713 41.4639 13.6286 43.7784 16.5153 43.7757L45.7597 43.7485V43.7485C46.1036 45.6904 44.8078 47.541 42.8654 47.882L13.2175 53.0871C10.3454 53.5913 7.60485 51.6724 7.09634 48.801L0.938773 14.031Z"
                      />
                    </mask>
                    <path
                      d="M10.6852 6.85405L12.6854 6.823L12.645 4.43508L10.3002 4.8914L10.6852 6.85405ZM11.2225 38.579L9.22225 38.6101L11.2225 38.579ZM16.5153 43.7757L16.52 45.7752L16.5153 43.7757ZM5.50787 9.8992L11.0702 8.81671L10.3002 4.8914L4.73791 5.97389L5.50787 9.8992ZM8.68499 6.8851L9.22225 38.6101L13.2227 38.548L12.6854 6.823L8.68499 6.8851ZM16.52 45.7752L45.7644 45.748L45.7551 41.749L16.5107 41.7762L16.52 45.7752ZM42.5166 45.9127L12.8688 51.1177L13.5663 55.0565L43.2141 49.8514L42.5166 45.9127ZM9.06622 48.4552L2.90865 13.6851L-1.0311 14.3768L5.12647 49.1468L9.06622 48.4552ZM43.7898 44.0943C43.9411 44.9486 43.3711 45.7627 42.5166 45.9127L43.2141 49.8514C46.2445 49.3194 48.2661 46.4322 47.7296 43.4026L43.7898 44.0943ZM9.22225 38.6101C9.28961 42.5878 12.5398 45.7789 16.52 45.7752L16.5107 41.7762C14.7174 41.7779 13.253 40.3401 13.2227 38.548L9.22225 38.6101ZM12.8688 51.1177C11.0846 51.431 9.38211 50.2389 9.06622 48.4552L5.12647 49.1468C5.82759 53.1059 9.60622 55.7517 13.5663 55.0565L12.8688 51.1177ZM4.73791 5.97389C0.842724 6.73194 -1.72311 10.4692 -1.0311 14.3768L2.90865 13.6851C2.59686 11.9246 3.7529 10.2407 5.50787 9.8992L4.73791 5.97389Z"
                      fill="#C0C0C0"
                      mask="url(#path-1-inside-1_1073_12020)"
                    />
                    <path
                      d="M10.0264 40.8573L17.3901 31.4928C18.1912 30.4739 19.7126 30.4104 20.5959 31.359L24.509 35.5613C25.481 36.6051 27.1868 36.4053 27.8912 35.1651L34.0506 24.3201C34.8398 22.9305 36.8249 22.8857 37.6721 24.2407C41.0126 29.5831 47.6635 40.257 47.8539 40.8573C48.1085 41.6598 43.366 45.1065 43.366 45.1065H12.1659L10.0264 40.8573Z"
                      fill="#FC7B52"
                    />
                    <rect
                      x="10.0361"
                      y="1"
                      width="36.9639"
                      height="43.7605"
                      rx="4.28"
                      stroke="#C0C0C0"
                      strokeWidth="2"
                    />
                    <path
                      d="M20.263 20.9186C22.0866 20.9186 23.565 19.4552 23.565 17.65C23.565 15.8448 22.0866 14.3813 20.263 14.3813C18.4393 14.3813 16.9609 15.8448 16.9609 17.65C16.9609 19.4552 18.4393 20.9186 20.263 20.9186Z"
                      fill="#FC7B52"
                    />
                  </svg>

                  <p>Add cover</p>
                </>
              ) : (
                <img className="cover" src={cover.url as any} alt="icon" />
              )}

              <CropperForImage
                type={"create"}
                picture={handleClickAddCover}
                typeInput={"change"}
                loading={!canEdit ? () => user.setLoading(true) : undefined}  // TODO: Disabled loading for edit cover
              />
            </label>
          </>
        ) : null}

        {editState && canEdit &&
        (type === ELinkType.Regular ||
          type === ELinkType.ProLink ||
          type === ELinkType.Audio ||
          type === ELinkType.Video ||
          type === ELinkType.Separator ||
          props.type === ELinkType.Subscription) ? (
          <TextField
            id="title"
            name="title"
            label="Title"
            value={title}
            onChange={handleOnChangeTitle}
            type="text"
            variant="outlined"
            error={!!errors.title}
            helperText={errors.title}
          />
        ) : null}

        <div className='inline_form'>
          {editState && canEdit && (type === ELinkType.Regular) ? (
            <FormControl fullWidth>
                <InputLabel id="url-type-label">Type</InputLabel>
                <Select
                    labelId="url-type-label"
                    id="url-type-select"
                    value={urlType}
                    variant="outlined"
                    label="Type"
                    onChange={handleOnChangeUrlType}
                    disabled={!canEdit}
                >
                  <MenuItem value={"0"}>url:</MenuItem>
                  <MenuItem value={"1"}>mailto:</MenuItem>
                  <MenuItem value={"2"}>tel:</MenuItem>
                  <MenuItem value={"3"}>sms:</MenuItem>
                  <MenuItem value={"4"}>maps:</MenuItem>
                  <MenuItem value={"5"}>geo:</MenuItem>
                </Select>
              </FormControl>
              /*<TextField
                  id="redirectToUrl"
                  label="Redirect to Url"
                  name="Redirect to Url"
                  variant="outlined"
                  value={url}
                  onChange={handleOnChangeUrl}
                  error={!!errors.url}
                  helperText={errors.url}
                  disabled={!canEdit}
              />*/
          ) : null}
          {canEdit && editState && (type !== ELinkType.Separator) ? (
            <TextField
                    id="redirectToUrl"
                    name="Redirect to Url"
                    label={
                        type === ELinkType.Subscription ? "Thank you message" : "Redirect to Url"
                    }
                    value={url}
                    onChange={handleOnChangeUrl}
                    type={type === ELinkType.Subscription ? "text" : "url"}
                    variant="outlined"
                    error={!!errors.url}
                    helperText={errors.url}
                    disabled={!canEdit}
            />
          ) : null}
        </div>
        {canEdit && editState ? (
          <button
            className="btn__outline btn__custom btn_medium link_save_home"
            onClick={handleUpdateLink}
          >
            Save
          </button>
        ) : null}
      </div>
    );
  };

  return (
    <div className={`setting_card ${
        props.link.type === ELinkType.Separator
            ? "setting_card__separator"
            : ""}`}>
      <div
        className={`${
          props.link.type === ELinkType.ProLink
            ? "setting_card__top " + "setting_card__top__pro"
            : "setting_card__top"
        } ${
          props.link.type !== ELinkType.ProLink &&
          props.link.type !== ELinkType.Video &&
          props.link.type !== ELinkType.Audio &&
          props.link.type !== ELinkType.Separator
            ? "setting_card__top__regular"
            : props.link.type === ELinkType.Separator 
              ? "setting_card__top__separator" 
              : "" 
        } ${editState && canEdit ? "edit" : ""}`}
      >
        {props.link.type !== ELinkType.Subscription &&
          props.link.type !== ELinkType.Separator
        ? (
          <a
            href={(editState && canEdit ? props.link.url : props.link.currentUrl) || "/"}
            ping={props.link.url || "/"}
            className={styles.olink_url}
            target="_blank"
          >
            olink url
          </a>
        ) : null}

        {props.link.type !== ELinkType.Regular &&
          props.link.type !== ELinkType.ProLink &&
          props.link.type !== ELinkType.Subscription &&
          props.link.type !== ELinkType.Separator &&
          !editState && (
            <picture className={"setting_card__icon"}>
              {props.link.type === ELinkType.Audio ||
              props.link.type === ELinkType.Video ? (
                <>
                  <>
                    {props?.preview ? (
                      <img src={props?.preview?.url} />
                    ) : (
                      getCover(props.link)
                    )}
                  </>
                </>
              ) : (
                getCover(props.link)
              )}
            </picture>
          )}

        {props.link.type === ELinkType.ProLink &&
          (props.link.cover && !editState ? (
            /* when image is added*/
            <img
              className={"setting_card__icon"}
              src={props.link.cover.url!}
              alt="Cover"
            />
          ) : (
            !editState /*&& canEdit*/ && (
              <>
                {width > 767 ? (
                  <picture className={"setting_card__icon"}>
                    {getCover(props.link)}
                  </picture>
                ) : (
                  <div
                    className={
                      "setting_card__icon " + "setting_card__empty_cover"
                    }
                  >
                    <img
                      src={add_cover_white}
                      alt="Add Cover"
                      width={32}
                      height={36}
                    />
                  </div>
                )}
              </>
            )
          ))}

        {/* {editState && canEdit &&
          (props.link.type === ELinkType.Audio ||
            props.link.type === ELinkType.Video) && (
            <>
              <h5 className={"setting_card__type text-black text-overflow"}>
                {props.link.title}
              </h5>
              <div className={"setting_card__text text-overflow"}>
                {props.link.url}
              </div>
            </>
          )} */}

        {props.link.type !== ELinkType.Subscription && !editState ? (
          <>
            <h5
              className={`setting_card__type text-black ${
                props.link.type !== ELinkType.Separator
                  ? "text-overflow "
                  : ""
              } ${
                styles.name_grid
              } ${
                props.link.type == ELinkType.ProLink ||
                props.link.type === ELinkType.Video ||
                props.link.type === ELinkType.Audio ||
                props.link.type !== ELinkType.Separator
                  ? styles.align_center
                  : ""
              }`}
            >
              {props.link.title}
            </h5>
          </>
        ) : (
          <>
            {props.role ? (
              <>
                {!editState ? (
                  <>
                    <h5
                      className={"setting_card__type text-black text-overflow"}
                    >
                      {props.link.title}
                    </h5>
                    <button
                      className={`${styles.subs_btn} icon btn_medium
                       btn__outline btn__custom link_save_home`}
                      onClick={handleDownloadList}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7.55929 9.53911C7.24338 9.23022 6.73688 9.23591 6.42799 9.55182C6.11911 9.86773 6.1248 10.3742 6.44071 10.6831L7.55929 9.53911ZM12 15L11.4407 15.572L12 16.1189L12.5593 15.572L12 15ZM17.5593 10.6831C17.8752 10.3742 17.8809 9.86773 17.572 9.55182C17.2631 9.23591 16.7566 9.23022 16.4407 9.53911L17.5593 10.6831ZM12.8 4C12.8 3.55817 12.4418 3.2 12 3.2C11.5582 3.2 11.2 3.55817 11.2 4L12.8 4ZM6.44071 10.6831L11.4407 15.572L12.5593 14.428L7.55929 9.53911L6.44071 10.6831ZM12.5593 15.572L17.5593 10.6831L16.4407 9.53911L11.4407 14.428L12.5593 15.572ZM12.8 15L12.8 4L11.2 4L11.2 15L12.8 15Z" />
                        <path d="M6 19.2C5.55817 19.2 5.2 19.5582 5.2 20C5.2 20.4418 5.55817 20.8 6 20.8V19.2ZM18 20.8C18.4418 20.8 18.8 20.4418 18.8 20C18.8 19.5582 18.4418 19.2 18 19.2V20.8ZM6 20.8H18V19.2H6V20.8Z" />
                      </svg>
                      {width > 767 ? "  Download Data" : "  Download Data List"}
                    </button>
                  </>
                ) : null}
              </>
            ) : (
              <>
                {!subscriptionMess ? (
                  <>
                    {!activeSubscription ? (
                      <button
                        className={`${styles.subscription__main_btn} text-overflow`}
                        onClick={handleClickSubscriptionState}
                      >
                        {props.link.title}
                      </button>
                    ) : (
                      <div className={styles.subscription}>
                        <TextField
                          className={styles.subscription__input}
                          id="email"
                          name="email"
                          label="Email"
                          value={email}
                          onChange={handleOnChangeGuestEmail}
                          type="text"
                          variant="outlined"
                          error={!!errors.email}
                          helperText={errors.email}
                          disabled={!canEdit}
                        />
                        <button
                          className={styles.subscription__btn}
                          onClick={handleSubscription}
                        >
                          <img src={arrow} alt="go forward button" />
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  props.link.type === ELinkType.Separator
                    ? null
                    :
                  <button
                    className={`${styles.subscription__main_btn} text-overflow`}
                    onClick={handleClickSubscriptionReopen}
                  >
                    {props.link.url}
                  </button>
                  // <h5
                  //   className={`${styles.subscription__thanks} text-black  text-overflow setting_card__type`}
                  // >
                  //   {props.link.url}
                  // </h5>
                )}
              </>
            )}
          </>
        )}

        {/*{props.role && props.link.type !== ELinkType.Subscription && (*/}
        <ProtectedAction>
        <button
          className={"setting_card__swap"}
          onClick={handleOnReorder}
          tabIndex={-1}
          aria-hidden={true}
        >
          <svg
            className="icon-swap"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.4343 17.4343C11.7467 17.1219 12.2533 17.1219 12.5657 17.4343C12.8781 17.7467 12.8781 18.2533 12.5657 18.5657L11.4343 17.4343ZM8 22L8.56569 22.5657L8 23.1314L7.43431 22.5657L8 22ZM3.43431 18.5657C3.1219 18.2533 3.1219 17.7467 3.43431 17.4343C3.74673 17.1219 4.25327 17.1219 4.56569 17.4343L3.43431 18.5657ZM7.2 3C7.2 2.55817 7.55817 2.2 8 2.2C8.44183 2.2 8.8 2.55817 8.8 3L7.2 3ZM12.5657 18.5657L8.56569 22.5657L7.43431 21.4343L11.4343 17.4343L12.5657 18.5657ZM7.43431 22.5657L3.43431 18.5657L4.56569 17.4343L8.56569 21.4343L7.43431 22.5657ZM7.2 22L7.2 3L8.8 3L8.8 22L7.2 22Z"
              fill="#585858"
            />
            <path
              d="M19.4343 6.56569C19.7467 6.8781 20.2533 6.8781 20.5657 6.56569C20.8781 6.25327 20.8781 5.74673 20.5657 5.43431L19.4343 6.56569ZM16 2L16.5657 1.43431L16 0.868629L15.4343 1.43431L16 2ZM11.4343 5.43431C11.1219 5.74673 11.1219 6.25326 11.4343 6.56568C11.7467 6.8781 12.2533 6.8781 12.5657 6.56568L11.4343 5.43431ZM15.2 11C15.2 11.4418 15.5582 11.8 16 11.8C16.4418 11.8 16.8 11.4418 16.8 11L15.2 11ZM20.5657 5.43431L16.5657 1.43431L15.4343 2.56568L19.4343 6.56569L20.5657 5.43431ZM15.4343 1.43431L11.4343 5.43431L12.5657 6.56568L16.5657 2.56569L15.4343 1.43431ZM15.2 2L15.2 11L16.8 11L16.8 2L15.2 2Z"
              fill="#585858"
            />
          </svg>
        </button>
        </ProtectedAction>
        {/*)}*/}

        {props.role && canEdit ? (
          <EditForm
            url={props.link.url}
            urlType={props.link.urlType}
            title={props.link.title}
            type={props.link.type}
            cover={props.link.cover}
            id={props.link.id}
            visible={props.link.visible}
            onUpdate={handleOnUpdate}
          />
        ) : null}
      </div>

      {props.role ? (
        <>
          {!deleteState && (
            <div className={"setting_card__bottom transition-500"}>
              {!deleteState && props.role ? (
                <div
                  className={
                    props.link.visible
                      ? "setting_card__checkbox setting_card__checkbox__on"
                      : "setting_card__checkbox"
                  }
                >
                  <span className="card__hide">Hide</span>
                  <Switch
                    className="styled_checkbox"
                    checked={props.link.visible!}
                    onChange={handleOnVisible}
                    inputProps={{ "aria-label": "Olink Hide-Show" }}
                    disabled={!canEdit}
                  />
                  <span className="card__show">Show</span>
                </div>
              ) : null}
              {!deleteState ? (
                <>
                  {editState && canEdit ? (
                    <button
                      className="setting_card__edit setting_card__edit_cross"
                      onClick={handlerOnEditClose}
                    >
                      <span className="visually-hidden">Edit Olink</span>
                      <svg
                        className="icon-cross"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 6L6 18M6 6l12 12"
                          stroke="#585858"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  ) : (
                    <ProtectedAction>
                    <button
                      className={"setting_card__edit"}
                      onClick={handlerOnEdit}
                    >
                      <span className="visually-hidden">Edit Olink</span>
                      <svg
                        className="icon-pen"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="a"
                          maskUnits="userSpaceOnUse"
                          x="4"
                          y="3"
                          width="17"
                          height="17"
                          fill="#000"
                        >
                          <path fill="#fff" d="M4 3h17v17H4z" />
                          <path d="M14.586 6.414l-7.194 7.194c-.195.195-.292.292-.36.41-.066.119-.1.252-.166.52l-.664 2.654c-.09.36-.135.541-.035.641.1.1.28.055.641-.035l2.655-.664c.267-.066.4-.1.518-.167.119-.067.216-.164.41-.359l7.195-7.194c.667-.666 1-1 1-1.414 0-.414-.333-.748-1-1.414l-.172-.172c-.667-.666-1-1-1.414-1-.414 0-.748.334-1.414 1z" />
                        </mask>
                        <path
                          d="M7.392 13.608l1.131 1.132-1.131-1.132zm7.194-7.194l-1.132-1.131 1.132 1.131zm2.828 0l-1.131 1.132 1.131-1.132zm.172.172l1.131-1.132-1.131 1.132zm0 2.828l1.131 1.132-1.131-1.132zm-7.194 7.194L9.26 15.477l1.132 1.131zm-3.526-2.07l1.552.387-1.552-.388zm-.664 2.654l-1.552-.389 1.552.389zm.606.606l-.388-1.552-.07.017-.067.024.525 1.51zm2.655-.664l-.388-1.552.388 1.552zm-3.296.7l1.131-1.132-1.131 1.131zm.641-.036l.388 1.552.07-.017.068-.024-.526-1.511zm3.173-.83l-.788-1.393.788 1.392zm7.605-7.554l1.131 1.132-1.131-1.132zM7.033 14.02L5.64 13.23l1.393.789zm1.49.72l7.194-7.193-2.263-2.263-7.194 7.194 2.263 2.263zm7.76-7.193l.171.171 2.263-2.263-.171-.171-2.263 2.263zm.171.737L9.26 15.477l2.263 2.263 7.194-7.194-2.263-2.263zm-11.14 5.866l-.664 2.655 3.104.776.664-2.654-3.105-.777zm1.883 5.201l2.654-.663-.776-3.105-2.655.664.777 3.104zM4.65 16.803c-.032.129-.105.402-.13.651-.026.27-.045.95.515 1.51l2.263-2.262c.208.207.326.454.379.68.045.197.032.345.028.384-.004.044-.009.057.001.01l.048-.196-3.104-.776zm1.633-.516l1.051 3.022-1.051-3.022zm.137-.041a8.663 8.663 0 01-.196.048c-.047.01-.034.005.01 0 .04-.003.187-.016.383.03.227.051.474.17.681.378l-2.263 2.263c.56.56 1.242.54 1.51.514.25-.024.523-.097.651-.129l-.776-3.104zm2.84-.77a15.51 15.51 0 01-.172.17l.02-.016a.798.798 0 01.085-.055l1.577 2.785c.35-.2.619-.486.753-.62L9.26 15.477zm.59 3.21c.185-.046.569-.128.92-.326l-1.577-2.785a.797.797 0 01.09-.044c.023-.01.034-.012.025-.01-.01.003-.031.01-.073.02l-.16.041.776 3.105zm6.604-10.969c.171.171.302.301.41.415.108.115.168.184.2.226.031.042.01.023-.017-.044A.831.831 0 0116.986 8h3.2c0-.698-.303-1.222-.578-1.583-.247-.324-.59-.661-.89-.963l-2.264 2.263zm2.263 2.829l-2.263-2.263 2.263 2.263zm0 0c.302-.302.644-.64.89-.963.276-.36.579-.885.579-1.583h-3.2c0-.124.027-.234.06-.314.028-.067.05-.086.018-.044a3.005 3.005 0 01-.2.226 24.36 24.36 0 01-.41.415l2.263 2.263zm-3-3c.171-.171.301-.302.415-.41a2.98 2.98 0 01.226-.2c.041-.031.023-.01-.044.017a.832.832 0 01-.314.061v-3.2c-.698 0-1.222.303-1.583.578-.324.247-.661.59-.963.89l2.263 2.264zm2.829-2.263c-.302-.302-.64-.644-.963-.89-.36-.276-.885-.579-1.583-.579v3.2a.832.832 0 01-.314-.06c-.067-.028-.085-.05-.044-.018.042.033.111.091.226.2.114.108.244.239.415.41l2.263-2.263zM6.26 12.477c-.134.134-.42.402-.62.753l2.785 1.577a.809.809 0 01-.055.085l-.016.02.052-.055.117-.117-2.263-2.263zm2.158 2.448l.04-.16.02-.073-.009.024a.808.808 0 01-.044.09L5.64 13.23c-.198.351-.28.735-.327.92l3.105.775z"
                          fill="#585858"
                          mask="url(#a)"
                        />
                        <path
                          d="M15.566 7.434a.8.8 0 00-1.132 1.132l1.132-1.132zm-.132 2.132a.8.8 0 001.132-1.132l-1.132 1.132zm-1-1l1 1 1.132-1.132-1-1-1.132 1.132z"
                          fill="#585858"
                        />
                      </svg>
                    </button>
                    </ProtectedAction>
                  )}
                </>
              ) : null}

              {!deleteState ? (
                <ProtectedAction>
                <button
                  className={"setting_card__delete"}
                  onClick={handlerOnDelete}
                >
                  <span className="visually-hidden">Delete Olink</span>
                  <svg
                    className="icon-delete"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.786 11.07l-1.285 9.8h-9l-1.286-9.8M4.285 7.5h15.429M8.734 7.127V4.903a1.286 1.286 0 011.286-1.286h3.857a1.286 1.286 0 011.286 1.286v2.571"
                      stroke="#585858"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                </ProtectedAction>
              ) : null}
            </div>
          )}
        </>
      ) : null}

      {canEdit && deleteState && (
        <div className={"delete"}>
          <p className="ff-gilroy text-center mb-20 dlt_clr__home">
            Delete this forever?
          </p>
          <div className={"delete__state"}>
            <button className="delete__no dlt_clr__home" onClick={closeDelete}>
              Cancel
            </button>
            <button
              className={"delete__yes"}
              onClick={handlerOnDeleteConfirmed}
            >
              Delete
            </button>
          </div>
        </div>
      )}
    </div>
  );
});

export default UserLinkHome;
